import { EPlatformNoticeAudienceType } from "../../Enum/EPlatformNoticeAudienceType"
import { EPlatformNoticeCategoryType } from "../../Enum/EPlatformNoticeCategoryType"
import { EPlatformNoticePriorityType } from "../../Enum/EPlatformNoticePriorityType"

export class SavePlatformNotice {
  title: string

  message: string

  categoryType: EPlatformNoticeCategoryType

  priorityType: EPlatformNoticePriorityType

  audienceType: EPlatformNoticeAudienceType

  isActive: boolean

  publishAtUtc?: string

  expiresAtUtc?: string

  targetUserIds: string[]

  constructor(data: Partial<SavePlatformNotice> = {}) {
    this.title = data.title ?? ""

    this.message = data.message ?? ""

    this.categoryType = data.categoryType ?? EPlatformNoticeCategoryType.General

    this.priorityType = data.priorityType ?? EPlatformNoticePriorityType.Normal

    this.audienceType = data.audienceType ?? EPlatformNoticeAudienceType.AllRestaurants

    this.isActive = data.isActive ?? true

    this.publishAtUtc = data.publishAtUtc

    this.expiresAtUtc = data.expiresAtUtc

    this.targetUserIds = data.targetUserIds ?? []
  }
}
